import {Injectable} from '@angular/core';
import {defaults as initialState, PlayerStateModel} from '../store/player.state';

const toSave = {
  volume: 1,
  volumeBeforeMute: 1,
  currentQuality: 1
};

@Injectable()
export class SettingsStoreService {
  constructor() {
  }

  getSettings(): PlayerStateModel {
    const defaults = initialState;
    let values = {};

    try {
      values = JSON.parse(localStorage.getItem('ggplayer-settings'));
      values = this.filterValues(values);
    } catch (e) {
    }

    return {
      ...defaults,
      ...values
    };
  }

  filterValues(state) {
    const ret = {};
    for (const key in toSave) {
      if (toSave[key]) {
        ret[key] = state[key];
      }
    }
    return ret;
  }

  saveSettings(state) {
    const values = this.filterValues(state);
    localStorage.setItem('ggplayer-settings', JSON.stringify(values));
  }
}
